<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
      <div class="back-btn" @click="goBack">
        <img src="https://retail-terminal-management.oss-cn-shanghai.aliyuncs.com/terminal-admin/store-back.png">
        <span>返回</span>
      </div>
    </div>
    <div class="detail-info-basic-container">
      <Title title="基本信息" :space="false" />
      <div class="detail-info-basic-box">
        <div class="detail-info-basic-box-info">
          <div class="detail-info-basic-box-head">
            <img :src="data.avatar ? data.avatar : avatarImage" class="head">
          </div>
          <div class="detail-info-basic-box-content">
            <span class="name">{{ data.createByInfo }}</span>
            <p v-if="data.companyList" class="phone">
              来自 <span v-for="(item, index) in data.companyList" :key="index">{{ item.companyName }}</span>
            </p>
          </div>
        </div>
        <div class="detail-info-basic-box-data">
          <div class="two-box">
            <div>
              <detail-bar title="标题" :content="data.ideaTitle" :bold="true" />
            </div>
            <div>
              <detail-bar title="分类" :content="data.classifyIdInfo" :bold="true" />
            </div>
          </div>
          <div class="two-box">
            <div>
              <detail-bar title="评论数" :content="data.commentNum ? data.commentNum : 0" :bold="true" />
            </div>
            <div>
              <detail-bar title="点赞数" :content="data.likeNum ? data.likeNum : 0" :bold="true" />
            </div>
          </div>
          <div class="one-box">
            <detail-bar title="文章内容" :content="data.ideaContent" />
            <p v-if="imageList.length > 0" class="title">
              文章图片
            </p>
            <div class="article-img">
              <div v-for="(item,index) in imageList" :key="index" class="img-list">
                <img :src="item.picUrl" class="img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <Title v-if="commentList.length > 0" title="评论信息" :space="false" />
      <div v-if="commentList.length > 0" class="comment-list">
        <div v-for="(item, index) in commentList" :key="index" class="comment-item">
          <div class="comment-item-heard">
            <img :src="item.avatar ? item.avatar : avatarImage" class="avatar">
            <span class="name">{{ item.createByInfo ? item.createByInfo : '用户已被删除' }}</span>
            <span v-if="item.companyName" class="from">来自 {{ item.companyName }}</span>
          </div>
          <div v-if="item.parentComment" class="reply-container">
            <div class="reply-article">
              <span>{{ item.parentCreateByInfo ? item.parentCreateByInfo : '用户已被删除' }} </span> {{ item.parentComment }}
            </div>
            <div class="reply">
              {{ item.content }}
            </div>
          </div>
          <div v-else class="article">
            {{ item.content }}
          </div>
        </div>
        <div style="margin-top: 20px; text-align: right">
          <el-pagination
            :current-page="current"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import Title from '@/components/title/Title'
import DetailBar from '@/components/bar/DetailBar'
import avatarImage from '@/assets/images/avatar.png'
import { goldenIdeaDetail, goldenIdeaPicPage, goldenIdeaCommentPage } from '@/api/index'
export default {
  components: {
    ThirdRouterNav,
    Title,
    DetailBar
  },
  data() {
    return {
      avatarImage,
      imageList: [],
      id: '',
      data: {},
      commentList: [],
      current: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getGoldenIdeaDetail()
    this.getGoldenIdeaPic()
    this.goldenIdeaCommentPage()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    /**
     * 金点子详情接口
     */
    getGoldenIdeaDetail() {
      goldenIdeaDetail(this.id).then((res) => {
        console.log(res.data)
        this.data = res.data
      })
    },
    /**
     * 金点子详情图片
     */
    getGoldenIdeaPic() {
      const data = {
        goldenIdeaId: this.id
      }
      goldenIdeaPicPage(data).then((res) => {
        console.log(res.data.records)
        this.imageList = res.data.records
      })
    },
    handleSizeChange(val) {
      this.size = val
      this.goldenIdeaCommentPage()
    },
    handleCurrentChange(val) {
      this.current = val
      this.goldenIdeaCommentPage()
    },
    /**
     * 金点子评论
     */
    goldenIdeaCommentPage() {
      const data = {
        current: this.current,
        size: this.size,
        goldenIdeaId: this.id
      }
      goldenIdeaCommentPage(data).then((res) => {
        this.commentList = res.data.records
        this.total = res.data.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: 100%;
    flex: 1;
    .menu-router-container {
      display: flex;
      justify-content: space-between;
      background-color: #ebeeef;
      .back-btn {
        width: 80px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DFE0E3;
        margin-left: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 14px;
          height: 14px
        }
        span {
          margin-left: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #1F2329;
        }
      }
      .simple-menu-right {
        width: 200px;
        margin-right: 40px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          margin-left: 15px;
        }
      }
    }
    .detail-info-basic-container {
      width: 836px;
      margin: 0 auto;
      padding: 20px;
      .comment-list {
        .comment-item:last-child {
          border-bottom: none;
        }
        .comment-item {
          padding: 20px 0 12px;
          border-bottom: 1px solid rgba(207, 207, 207, 0.5);
          .comment-item-heard {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .avatar {
              width: 40px;
              height: 40px;
            }
            .name {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #212121;
              margin-left: 8px;
            }
            .from {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #7B7B7B;
              margin-left: 8px;
            }
          }
          .reply-container {
            .reply-article {
              margin-top: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              margin-left: 44px;
              text-align: justify;
              color: #7B7B7B;
              font-weight: 400;
              background: #F7F7F7;
              border-radius: 2px;
              padding: 20px 24px;
              span {
                color: #212121;
                font-weight: bold;
                margin-right: 8px;
              }
            }
            .reply {
              margin-top: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #212121;
              margin-left: 44px;
              text-align: justify;
            }
          }
          .article {
            margin-top: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #212121;
            margin-left: 44px;
            text-align: justify;
          }
          .more-icon-box {
            display: flex;
            justify-content: flex-end;
            margin-top: 20px;
            .more-icon {
              width: 36px;
              height: 36px;
            }
          }
        }
      }
      .detail-info-basic-box {
        margin-top: 21px;
        margin-bottom: 21px;
        .detail-info-basic-box-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .detail-info-basic-box-head {
            position: relative;
            .head {
              width: 64px;
              height: 64px;
              border-radius: 32px;
            }
            .sex {
              width: 22px;
              height: 22px;
              position: absolute;
              left: 42px;
              bottom: 0px;
            }
          }
          .detail-info-basic-box-content {
            margin-left: 12px;
            .name {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #1F2329;
            }
            .phone {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #646A73;
              margin-top: 2px;
              span {
                margin-right: 4px;
              }
            }
          }
        }
        .detail-info-basic-box-data {
          margin-top: 24px;
          .two-box {
            display: flex;
            justify-content: space-between;
            >div {
              width: calc(50% - 6px);
            }
          }
          .one-box {
            .title {
              height: 22px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #646A73;
              line-height: 22px;
            }
            .tag {
              .title {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #646A73;
                line-height: 22px;
                margin-bottom: 8px;
              }
            }
            .article-img {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              overflow: hidden;
              margin-top: 8px;
              .img-list:nth-child(6n + 6) {
                margin-right: 0;
              }
              .img-list {
                width: 120px;
                height: 120px;
                border-radius: 12px;
                margin-bottom: 12px;
                margin-right: 22px;
                position: relative;

                .img {
                  width: 120px;
                  height: 120px;
                  border-radius: 12px;
                }

                .delete {
                  position: absolute;
                  right: 0;
                  top: 0;

                  img {
                    width: 32px;
                    height: 32px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
